var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreDrawer, {
    attrs: {
      value: _setup.value,
      title: _vm.title,
      "is-back": _vm.isBack,
      attach: _vm.attach,
      "title-truncate": _vm.titleTruncate,
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", false)
      },
      back: function ($event) {
        return _vm.$emit("back")
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [
              _setup.isVisibleSearch
                ? _c(_setup.CoreSearchField, {
                    staticClass: "mt-2",
                    attrs: {
                      autofocus: "",
                      maxlength: "150",
                      placeholder: _vm.placeholder || _vm.title,
                    },
                    on: {
                      "click:clear": _setup.handleClickClear,
                      input: function ($event) {
                        return _vm.$emit("search:change", $event)
                      },
                    },
                    model: {
                      value: _setup.searchQuery,
                      callback: function ($$v) {
                        _setup.searchQuery =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "searchQuery",
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "append-header",
          fn: function () {
            return [_vm._t("append-header")]
          },
          proxy: true,
        },
        {
          key: "default",
          fn: function () {
            return [
              _setup.error
                ? _c(_setup.DrawerError, { staticClass: "py-9" })
                : _setup.loading
                ? _c(_setup.DrawerSkeleton, { staticClass: "px-2" })
                : _c(_setup.CoreSelectionList, {
                    ref: "selectionListRef",
                    staticClass: "py-2",
                    attrs: {
                      items: _setup.items,
                      value: _setup.selectedItem || _setup.defaultItem,
                      "search-input": _vm.noFilter
                        ? undefined
                        : _setup.searchQuery,
                      "end-icon": _setup.endIcon,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("click-item", $event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "empty",
                          fn: function () {
                            return [
                              _vm._t("empty-list", function () {
                                return [
                                  _c(_setup.DrawerNotFound, {
                                    staticClass: "py-3",
                                  }),
                                ]
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
            ]
          },
          proxy: true,
        },
        _vm.hasFooter
          ? {
              key: "footer",
              fn: function () {
                return [_vm._t("footer")]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }